function api(url, options) {
    return fetch(url, options).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const contentType = response.headers.get("Content-Type");
        // @ts-expect-error Check for typing
        if (contentType.includes("application/json")) {
            return response.json();
        }
        return response.text();
    });
}
export default api;
//# sourceMappingURL=api.js.map
